<template>
  <div class="contact-form-fields">
    <div class="form-group">
      <label>Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control" v-model.trim="local.name" @input="emitChange" required />
    </div>

    <div class="form-group">
      <label class="form-control-label">Phone Number </label><br>
      <input
        ref="phoneInput"
        type="tel"
        class="form-control"
        placeholder="+91 9876543210"
        @input="syncFromIti"
      />
    </div>

    <div class="form-group">
      <label>Email</label>
      <input type="email" class="form-control" v-model.trim="local.email" @input="emitChange" />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, watch, onMounted, onBeforeUnmount, ref } from 'vue'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

export default defineComponent({
  name: 'ContactFormFields',
  props: {
    modelValue: {
      type: Object,
      default: () => ({ name: '', email: '', phone_code: '+91', phone: '' })
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const phoneInput = ref(null)
    let iti = null

    const local = reactive({ ...props.modelValue })

    watch(
      () => props.modelValue,
      v => Object.assign(local, v || {}),
      { deep: true }
    )

    const emitChange = () => emit('update:modelValue', { ...local })

    const syncFromIti = () => {
      try {
        if (!iti) return
        const data = iti.getSelectedCountryData()
        const dial = data?.dialCode ? `+${data.dialCode}` : ''
        local.phone_code = dial || local.phone_code || '+91'

        let e164 = ''
        if (window.intlTelInputUtils && iti.getNumber) {
          e164 = iti.getNumber(window.intlTelInputUtils.numberFormat.E164) || ''
        } else {
          e164 = iti.getNumber() || phoneInput.value?.value || ''
        }
        const digits = e164.replace(/\D/g, '')
        const dialDigits = (data?.dialCode || '').replace(/\D/g, '')
        const rest = dialDigits && digits.startsWith(dialDigits)
          ? digits.slice(dialDigits.length)
          : digits.replace(/^\+?/, '')

        local.phone = rest
        emitChange()
      } catch {
        /* noop */
      }
    }

    const initIti = () => {
      if (!phoneInput.value || iti) return
      try {
        iti = intlTelInput(phoneInput.value, {
          allowDropdown: true,
          nationalMode: false,
          separateDialCode: true,
          preferredCountries: ['in', 'us', 'gb'],
          utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js'
        })
        phoneInput.value.addEventListener('countrychange', syncFromIti)

        // set initial value
        const code = (local.phone_code || '+91').replace('+','')
        const digits = String(local.phone || '').replace(/\D/g, '')
        const full = (code || '') + digits

        if (full) {
          iti.setNumber(`+${full}`)
        } else if (code) {
          const arr = window?.intlTelInputGlobals?.getCountryData?.() || []
          const hit = arr.find(c => String(c.dialCode) === String(code))
          if (hit?.iso2) iti.setCountry(hit.iso2)
        }
        syncFromIti()
      } catch {
        /* noop */
      }
    }

    onMounted(initIti)
    onBeforeUnmount(() => {
      try {
        phoneInput.value?.removeEventListener('countrychange', syncFromIti)
        if (iti?.destroy) iti.destroy()
      } catch { /* noop */ }
      iti = null
    })

    return { local, emitChange, syncFromIti, phoneInput }
  }
})
</script>

<style>
.contact-form-fields .form-control{border-radius:10px;}
.iti{
  width:100%!important;
  display:flex!important;
}
.iti--allow-dropdown{width:100%;display:flex;}
.iti--allow-dropdown .form-control,
.iti--allow-dropdown input{
  width:100%!important;
  min-width:100%!important;
  display:block!important;
  border-radius:10px!important;
  height:44px;
  box-sizing:border-box;
  flex:1 1 auto;
}
.iti__tel-input{width:100%!important;flex:1 1 auto;}
.iti__flag-container{border-radius:10px 0 0 10px;height:100%;flex-shrink:0;}
.iti--separate-dial-code .iti__selected-dial-code{font-weight:600;}
.iti--separate-dial-code .iti__selected-dial-code{font-weight:600;}
</style>
